/*
header.controller.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/**
 * @ngdoc controller
 * @name uaf.appshell.HeaderCtrl
 * @description A controller for the default header which displays the product name and user name.
 */
define('modules/shell/controllers/header.controller',[
    'lodash',
    'system-config',
    '../module',
    '../services/application.service',
    '../services/login.service',
    '../services/user.service'
], function (_, systemConfig, shell) {
    'use strict';

    // Controller provides data to be displayed in the default header
    shell.controller('uaf.appshell.HeaderCtrl', [
        '$scope',
        '$rootScope',
        '$q',
        '$transitions',
        'uaf.appshell.AppConfig',
        'loginService',
        'ShellUserService',
        '$state',
        function ($scope, $rootScope, $q, $transitions, appConfig, loginService, UserService, $state) {

            $scope.hideHeader = false;
            $scope.showMenuItems = true;

            $scope.applicationName = systemConfig.applicationName;

            $scope.goAccountProfile = function() {
                $state.go('userSettings.accountAndProfile');
            };

            $scope.logout = function (global) {
                /**
                 * Execute the "beforeLogout" event handlers first & then logout
                 */
                $q(function (resolve, reject) {
                    var eventResponse = $rootScope.$broadcast('beforeLogout');
                    if (eventResponse.defaultPrevented) {
                        // This will prevent the logout event
                        reject();
                    } else {
                        resolve();
                    }
                }).then(function () {
                    UserService.reset();
                    loginService.logoutUser(global);
                }, function () {
                    console.log('Logout event has been prevented by one of the \'beforeLogout\' subscribers');
                });
            };

            function getFullName(name) {
                var given = name.given || [];
                var family = name.family || [];
                return given
                    .concat(family)
                    .map(function (n) {
                        return n && n[0].toUpperCase() + n.substr(1).toLowerCase() || '';
                    })
                    .join(' ')
                    .trim()
                    .replace(/\s+/g, ' ');
            }

            $transitions.onSuccess({}, function () {
                var activeModule = appConfig.getActiveModule();
                $scope.hideHeader = $scope.isHideHeader(activeModule);
                $scope.showMenuItems = $scope.isShowMenuItem(activeModule);
            });

            $scope.isHideHeader = function(activeModule){
                return !!(activeModule && (activeModule.hideHeader || !!activeModule.fullscreen));
            };

            $scope.isShowMenuItem = function(activeModule) {
                return !!(!activeModule || activeModule.showMenuItems !== 'false') && !!sessionStorage['cIdToken'];
            };

            $scope.$on('accountProfileChanged', function () {
                UserService.getUserName().then(function (result) {
                    var user = result;
                    $scope.userName = $scope.userName = getFullName({
                        given: [user.givenName],
                        family: [user.familyName]
                    });
                    $scope.userEmail = user.email;
                });
            });

            var init = function () {
                $rootScope.dataLoading('header');
                UserService.reset();
                var promise1 = UserService.getC360UsersData();
                var promise2 = UserService.getUserData();
                $q.all([promise1, promise2]).then(function (results) {
                    if (results.length > 0) {
                        var c360User = results[0], user = results[1];
                        $scope.isGeAdmin = c360User.isGeAdmin;
                        $scope.isGeAccountManager = c360User.isGeAccountManager;
                        $scope.isDefaultRole = c360User.isDefaultRole;

                        $scope.userName = $scope.userName = getFullName({
                            given: [user.givenName],
                            family: [user.familyName]
                        });
                        $scope.userEmail = user.email;
                        $scope.patient = user.isPatient;
                        $scope.siteadmin = user.siteAdmin;
                        $scope.orgadmin = user.orgAdmin;
                        $scope.geadmin = user.geAdmin;
                        $scope.onlyOrgLevelAccessUser = user.isOnlyOrgLevelAccessUser;
                        $scope.showAdminHelpLink = user.isAdmin;
                        $scope.geAccountManager = user.geAccountManager;
                        $scope.hasCaseExchangeAccess = c360User.hasCEAccess;
                        $scope.hasMDTAccess = c360User.hasMDTAccess;
                        $scope.hasPortalAccess = user.hasPortalAccess;
                        $scope.mdtCoordinator = user.isMDTCoordinator;
                    }
                    $scope.showCreateSiteLink = !$scope.patient && !$scope.onlyOrgLevelAccessUser && ($scope.isAdmin || $scope.isGeAdmin || $scope.isHealthcareProvider || ($scope.isDefaultRole && !$scope.isGeAccountManager));
                }).finally(function () {
                    $rootScope.dataLoaded('header');
                });
            };

            init();
        }
    ]);
});

